const counties = [
  'Abbeville',
  'Aiken',
  'Allendale',
  'Anderson',
  'Bamberg',
  'Barnwell',
  'Beaufort',
  'Berkeley',
  'Calhoun',
  'Charleston',
  'Cherokee',
  'Chester',
  'Chesterfield',
  'Clarendon',
  'Colleton',
  'Darlington',
  'Dillon',
  'Dorchester',
  'Edgefield',
  'Fairfield',
  'Florence',
  'Georgetown',
  'Greenville',
  'Greenwood',
  'Hampton',
  'Horry',
  'Jasper',
  'Kershaw',
  'Lancaster',
  'Lee',
  'Lexington',
  'Marion',
  'Marlboro',
  'McCormick',
  'Newberry',
  'Oconee',
  'Orangeburg',
  'Pickens',
  'Richland',
  'Saluda',
  'Spartanburg',
  'Sumter',
  'Union',
  'Williamsburg',
  'York',
  'Laurens',
];

export default counties;
